import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Layer, Image, Line, Stage, Text, Transformer } from 'react-konva';
import styles from './SketchLabel.styles';

const useStyles = makeStyles(styles);

const SketchLabel = ({ shapeProps, isSelected, onSelect, onTransformEnd, fill = '#2a2a2a' }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();
  const [deleteListener, setDeleteListener] = useState(null);

  React.useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Text
        fill={fill}
        onClick={onSelect}
        ref={shapeRef}
        {...shapeProps}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          const rotation = node.rotation();

          onTransformEnd({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation,
            scaleX,
            scaleY,
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          resizeEnabled={false}
          rotationSnaps={[0, 45, 90, 135, 180, 225, 270, 315]}
          // boundBoxFunc={(oldBox, newBox) => {
          //   // limit resize
          //   if (newBox.width < 5 || newBox.height < 5) {
          //     return oldBox;
          //   }
          //   return newBox;
          // }}
        />
      )}
    </React.Fragment>
  );
};

SketchLabel.defaultProps = {};
SketchLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  text: PropTypes.string,
  rotation: PropTypes.number,
};

export default SketchLabel;
